<template>
    <v-row no-gutters>
      <v-col class="pa-3">
        <v-row no-gutters class="my-3">
              <v-col class="group-resp" cols="12">
                <v-btn @click="type='create',addClassDialog=true,upgrade++" class="mb-3 mr-2">{{$t('page.eventClasses.create_class')}}</v-btn>
              </v-col>
        </v-row>
        <v-dialog v-model="addClassDialog" >
            <v-card-title style="background: #fff !important;"></v-card-title>
            <v-card>
              <v-card-text>
                  <v-row>
                      <FormClasses v-if="type=='edit'" @saveDate="saveDate" :type="type" :idClass="idClass" :key="upgrade" @closeDialog="addClassDialog =false" />
                      <FormClasses v-else @saveDate="saveDate" :type="type" :key="upgrade" @closeDialog="addClassDialog =false"/>
                  </v-row>
              </v-card-text>
            </v-card>
        </v-dialog>        
        <div class="containerDatatable" style="max-height: 600px; overflow-y: scroll;">
          <v-data-table
            ref="tableClass"
            :headers="headers"
            :items="listEvents"
            :items-per-page="listEvents.length"
            class="elevation-1 table-classes"
            style="margin: 0"
            hide-default-footer
            :footer-props="{
              'items-per-page-text': $t('dataTable.rowsPerPageText'),
              'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
            }"
            :no-data-text="$t('dataTable.noDataText')"
            :headerProps="{
              'sort-by-text': $t('dataTable.sortByText')
            }"
          >
            <template v-slot:top>
              <v-snackbar v-model="snackbarSuccess" color="success" multi-line>
                {{ $t("page.eventClasses.save-success") }}
                <v-btn dark @click="snackbarSuccess = false" style="color: #fff !important; float: right">
                  {{ $t("page.eventClasses.close-sn") }}
                </v-btn>
              </v-snackbar>
              <v-snackbar class="snackError" v-model="snackbar" multi-line>
                {{ $t("page.eventClasses.confirm-delete") }}
                <template v-slot:action="{ attrs }">
                  <v-btn color="pink" text v-bind="attrs" @click="_delete">{{
                    $t("page.eventClasses.delete")
                  }}</v-btn>
                </template>
              </v-snackbar>
              <v-snackbar v-model="snackbarError" color="error" multi-line>
                {{ msgError }}
                <v-btn
                  dark
                  style="color: #fff !important; float: right"
                  @click="snackbarError = false"
                  >{{ $t("page.eventClasses.close-sn") }}</v-btn
                >
              </v-snackbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="type='edit',idClass=item.id,addClassDialog=true,upgrade++">mdi-pencil-outline</v-icon>
                <v-icon small @click="deleteItem(item)">mdi-delete-outline</v-icon>
            </template>
          </v-data-table>
        </div>
      </v-col>
    </v-row>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import FormClasses from "@/views/events/classes/FormClasses.vue";

export default {
  mixins: [apiCalls],
  components: {
    FormClasses
  },
  data() {
    return {
      listEvents: [],
      editedIndex: -1,
      snackbar: false,
      deleteIndex: -1,
      snackbarError: false,
      msgError: "",
      addClassDialog:false,
      snackbarSuccess: false,
      type:'',
      idClass:'',
      upgrade:0
    };
  },
  computed: {
    headers: function () {
      return [
        { text: this.$t("page.eventClasses.class"), value: "cName", width: "1%" },
        { text: this.$t("page.eventClasses.row-limit"), value: "rowLimit", width: "1%" },
        {
          text: this.$t("page.eventClasses.reserved-position"),
          value: "reservedRows",
          width: "1%"
        },
        { text: this.$t("page.eventClasses.registered"), value: "registered", width: "1%" },
        { text: this.$t("page.eventClasses.group"), value: "classGroup", width: "1%" },
        { text: this.$t("page.eventClasses.start-time"), value: "startTime", width: "1%" },
        { text: this.$t("page.eventClasses.sort-order"), value: "sortOrder", width: "1%" },
        {
          text: this.$t("page.eventClasses.edit-delete"),
          value: "actions",
          sortable: false,
          align: 'center',
          width: "1%"
        },
      ];
    },
  },
  methods: {
    loadData: async function () {
      var response = await this.api(
        "get",
        "/api/v1/promoter/eventClass/" + this.$route.params.id
      );
      this.listEvents = response.message.data;
    },
    saveDate(value) {
      if(value){
        this.addClassDialog = false
        this.loadData();
        this.snackbarSuccess = true;
      }  
    },
    deleteItem(item) {
      const index = this.listEvents.indexOf(item);
      this.snackbar = true;
      this.deleteIndex = index;
    },
    _delete: async function () {
      const item = this.listEvents[this.deleteIndex];
      const response = await this.api(
        "delete",
        "/api/v1/promoter/eventClass/" + item.id
      );
      const { success, message } = response;
      if (success) {
        this.listEvents.splice(this.deleteIndex, 1);
        this.snackbar = false;
      } else {
        this.snackbar = false;
        this.msgError = this.$t(`page.eventClasses.${message[0]}`);
        this.snackbarError = true;
      }
    },
    editItem(item) {
      this.$router.push({ name: 'EditClasses', params: { id: this.$route.params.id, idClass: item.id }});
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style>
.not-card-title {margin: 0 20px;}

.snackError .v-btn{
  border-style: solid;
  border-image: initial;
  border-width: 1px;
  border-color: red !important;
  border-radius: 4px;
}
</style>
